export default `
  .px-03 {
    padding-right: 0.3rem!important;
    padding-left: 0.3rem!important;
  }
  .mb-6 {
    margin-bottom: 4rem !important;
  }
  .text-gray {
    color: var(--light-wl-gray);
  }
  .font-12 {
    font-size: 12px;
  }
  .font-14 {
    font-size: 14px;
  }
  .font-wl-line-height-12 {
    line-height: 12px !important;
  }
  .width-100 {
    width: 100% !important;
  }
  .text-left {
    text-align: left !important;
  }
  .padding-left-9 {
    padding-left: 9px !important;
  }
  .container ul.padding-left-9 {
    padding-left: 9px !important;
  }
  .margin-right-minus-25 {
    margin-right: -25px !important;
  }
  .margin-left-minus-25 {
    margin-left: -25px !important;
  }
  .link-default-wl {
    text-decoration: underline;
    color: var(--text-dark);
  }

  .link-cancel-wl {
    text-decoration: underline;
    color: var(--danger);
    font-weight: 600 !important;
  }

  .menu-wl {
    padding-bottom: 200px;
    margin-bottom: 80px;
    overflow: scroll;
    height: 100vh;
  }
  .menu-wl::-webkit-scrollbar {
    display: none;
  }
  .menu-wl ul {
      list-style-type: none;
  }

  .menu-wl ul li a {
      text-decoration: none;
      color: var(--primary-color);
      font-size: 1.0em;
      font-weight: bold;
  }

  .menu-wl ul li span {
      text-decoration: none;
      cursor: pointer;
      margin-left: 5%;
      
      font-style: normal;
      font-weight: 600;
      font-size: 15px;
      line-height: 145%;
      letter-spacing: -0.01em;
      color: var(--primary-color);
  }

  .menu-wl ul li span a {
      text-decoration: none;
      cursor: pointer;
      
      font-style: normal;
      font-weight: 600;
      font-size: 15px;
      line-height: 145%;
      letter-spacing: -0.01em;
      color: var(--primary-color);
  }

  .menu-title {
    font-family: Roboto;
    font-size: 16px;
    font-weight: 700;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: left;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    color: var(--primary-color);
  }

  .input-group-wl {
    align-items: center;
    position: absolute;
    right: 0;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    text-align: center;
    white-space: nowrap;
    border: 0;
    border-radius: 0.25rem;
  }

  .input-group-wl svg {
     
  }
  .carousel-wl {
    .carousel-indicators {
      align-items: center;
    }
    
    .carousel-indicators [data-bs-target] {
        width: 5px;
        height: 5px;
        border-radius: 100%;
        background-color:  var(--primary-color);
        border: 0;
    }
    
    .carousel-indicators .active {
        width: 8px;
        height: 8px;
        background-color: var(--primary-color);
    }
    
    .carousel-control-prev-icon{
        background-image: none !important;
    }
    
    .carousel-control-next-icon{
        background-image: none !important;
    }
    
    .carousel-indicators{
      margin-bottom: -20px !important;
    }
  }

  @media (min-width: 1024px) {
    .carousel {
      margin-top: 20px !important;
    }
  }

  .group-disabled-color {
    input {
      color: var(--primary-color);
    }
    }
    .group-checkbox-wl {
      input[type="checkbox"] {
        border-radius: 0;
        border-color: var(--text-dark);
      }
      input[type="checkbox"]:checked {
        background-color: var(--text-dark);
      }
      input[type="checkbox"]:focus {
        box-shadow: none;
      }
    }
    .modal-center {
      position: fixed;
      top: 80%;
      left: 50%;
      width: 90%;
      transform: translate(-50%, -50%);
    }
    .card-quantity {
      .input-group-text {
        border: 0;
        font-weight: 600;
        background:  var(--secondary-color);
        font-size: 14px;
        padding: 0.375rem 0.5rem;
      }
      .btn {
        border: 0px;
        background:  var(--button-primary-color);
        color: var(--secondary-color);
        font-weight: bold;
        font-size: 22px;
        padding: 0.375rem 0.5rem;
        border-radius: var(--button-border-radius);
      }
    }
    .border-highlight {
      box-shadow: 0 0 5px 1px var(--primary-color);
      border: 1px solid var(--warning);
      animation: fadeIn 1s;
    }
    .typography {
      display: flex;
      justify-content: space-between;
      margin: 0 0 1rem 1.5rem !important;
      font-size: 15px !important;
      color: var(--primary-color);
    }
    .no-border {
      border: 0 !important;
    }

    .line {
      border: 1px solid  var(--secondary-color);
      width: 90%;
    }
    .box-filter {
      overflow-y: scroll;
      height: 80px;
      width: 93%;
      margin: 0 0 1rem 0.5rem !important;
      &::-webkit-scrollbar {
        width: 9px;
      }
      &::-webkit-scrollbar-track {
        background: var(--primary-color); 
      }
      &::-webkit-scrollbar-thumb {
        background-color: var(--primary-color)
        border-radius: 10px;
      }
    }
    .form-label {
      font-weight: 400;
      font-size: 16px;
      line-height: 150%;
      color: var(--primary-color);
    }
`